export const API_BASE_URL = import.meta.env.PROD ? window.location.origin : 'http://localhost:8789';
export const API_PREFIX = import.meta.env.PROD ? '' : '/api';
export const MAX_FILE_SIZE = 2 * 1024 * 1024 * 1024; // 2GB
export const CHUNK_SIZE = 512 * 1024; // 512KB per chunk
